import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGmsClientCallbackComponent } from '@coin/shared/auth/feature';

// @ts-ignore
const routes: Routes = [
  {
    path: 'auth/callback',
    component: AuthGmsClientCallbackComponent
  },
  {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
